import React from 'react';
import './PrivacyScore.css';

function PrivacyScore() {
  return (
    <div className="page-container">
      <div className="header-section">
        <h1>Privacy Score</h1>
        <p className="lead">Privacy compliance and protection metrics</p>
      </div>

      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="score-card privacy">
              <div className="score-header">Privacy Score</div>
              <div className="score-value">92</div>
              <div className="score-trend positive">
                <i className="bi bi-arrow-up"></i>
                <span>+3 points this month</span>
              </div>
            </div>

            <div className="card compliance-card">
              <div className="card-body">
                <h3>Compliance Status</h3>
                <div className="compliance-item">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>GDPR</span>
                    <span className="badge bg-success">Compliant</span>
                  </div>
                </div>
                <div className="compliance-item">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>CCPA</span>
                    <span className="badge bg-success">Compliant</span>
                  </div>
                </div>
                <div className="compliance-item">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>HIPAA</span>
                    <span className="badge bg-warning">In Progress</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-body">
                <h3>Privacy Metrics</h3>
                <div className="metrics-grid">
                  <div className="metric-item">
                    <div className="metric-header">Data Encryption</div>
                    <div className="metric-value">95%</div>
                    <div className="metric-status positive">
                      <i className="bi bi-check-circle"></i>
                      <span>Secured</span>
                    </div>
                  </div>
                  <div className="metric-item">
                    <div className="metric-header">Access Control</div>
                    <div className="metric-value">88%</div>
                    <div className="metric-status positive">
                      <i className="bi bi-check-circle"></i>
                      <span>Protected</span>
                    </div>
                  </div>
                  <div className="metric-item">
                    <div className="metric-header">Data Retention</div>
                    <div className="metric-value">78%</div>
                    <div className="metric-status warning">
                      <i className="bi bi-exclamation-circle"></i>
                      <span>Review Needed</span>
                    </div>
                  </div>
                  <div className="metric-item">
                    <div className="metric-header">Consent Management</div>
                    <div className="metric-value">92%</div>
                    <div className="metric-status positive">
                      <i className="bi bi-check-circle"></i>
                      <span>Compliant</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <h3>Recent Privacy Updates</h3>
                <div className="timeline">
                  <div className="timeline-item">
                    <div className="timeline-date">Aug 28, 2025</div>
                    <div className="timeline-content">
                      <div className="timeline-title">Data Encryption Update</div>
                      <div className="timeline-description">Implemented enhanced encryption protocols</div>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-date">Aug 25, 2025</div>
                    <div className="timeline-content">
                      <div className="timeline-title">Privacy Policy Review</div>
                      <div className="timeline-description">Completed quarterly policy assessment</div>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-date">Aug 20, 2025</div>
                    <div className="timeline-content">
                      <div className="timeline-title">Access Control Audit</div>
                      <div className="timeline-description">Performed system-wide access review</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyScore;
